import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { TextField, Button, Select, MenuItem } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

import {
  getBaterias,
  getEnsambladoras,
  postBateria,
  deleteBateria,
  getPermisosByUser,
} from '@auteco/services/sostenibilidadService'

import './SostenibilidadBateriasContainer.css'

const SostenibilidadBateriasContainer = () => {
  const [data, setData] = useState([])
  const [ensambladora, setEnsambladora] = useState('')
  const [empresasList, setEmpresasList] = useState([])
  const [fecha, setFecha] = useState(null)
  const [cantidadBaterias, setCantidadBaterias] = useState(200)
  const [permisos, setPermisos] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const columns = [
    {
      title: 'Ensambladora',
      field: 'ensambladora_id',
      render: (rowData) => {
        const empresa = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        return empresa ? empresa.nombre : 'Desconocida'
      },
    },
    { title: 'Cantidad', field: 'cantidad', type: 'numeric' },
    { title: 'Fecha', field: 'fecha', type: 'date' },
  ]

  function formatearFechaEjemplo() {
    const fechaFormat = new Date(fecha)

    const año = fechaFormat.getFullYear()
    const mes = (fechaFormat.getMonth() + 1).toString().padStart(2, '0')
    const dia = fechaFormat.getDate().toString().padStart(2, '0')

    return `${año}-${mes}-${dia}`
  }

  const handleAdd = async () => {
    setIsLoading(true)
    const response = await postBateria({
      ensambladora_id: parseInt(ensambladora, 10),
      fecha: formatearFechaEjemplo(),
      cantidad: cantidadBaterias,
    })

    if (response) {
      handleGetBaterias()
    }
    setIsLoading(false)
  }

  const handleGetBaterias = async () => {
    const response = await getBaterias()
    if (response) {
      setData(response.baterias)
    }
  }

  const handleGetEmpresas = async () => {
    const { ensambladoras } = await getEnsambladoras()
    if (ensambladoras) {
      setEmpresasList(ensambladoras)
    }
  }

  const handleDeleteBateria = async (id) => {
    setIsLoading(true)

    const response = await deleteBateria(id)
    if (response) {
      handleGetBaterias()
    }
    setIsLoading(false)

  }

  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()
    if (response) {
      const bateriaPermiso = response.permisos.find(
        (permiso) => permiso.nombre === 'Baterias',
      )
      if (bateriaPermiso) {
        setPermisos(parseInt(bateriaPermiso.alcance, 10))

        
      }
    }
  }

  useEffect(() => {
    handleGetPermisosByUser()
    handleGetBaterias()
    handleGetEmpresas()
  }, [])

  return (
    <div>
      {permisos === 0 && <p>No tienes permisos para ver esta sección</p>}
      {permisos > 0 && (
        <div    className={` ${isLoading ? 'my-loading' : ''}`}>
        <MaterialTable
          title="Baterías"
          columns={columns}
          data={data}
       
          options={{
            headerStyle: {
              backgroundColor: '#f1f1f1',
              color: 'black',
              fontWeight: 'bold',
            },
          }}
          actions={[
            {
              icon: 'delete',
              tooltip: 'Eliminar',
              onClick: (event, rowData) => {
                handleDeleteBateria(rowData.id)
              },
            },
          ]}
        />
        </div>
      )}

      {permisos > 1 && (
        <div className={`container_baterias_form ${isLoading ? 'my-loading' : ''}`}>
          <h3>Registro baterías</h3>
          <div className="form_baterias">
            {' '}
            <p className="tit">Ensambladora</p>
            <Select
              value={ensambladora}
              onChange={(e) => setEnsambladora(e.target.value)}
              displayEmpty
              fullWidth
            >
              {empresasList &&
                empresasList.map((empresa) => (
                  <MenuItem value={empresa.id}>{empresa.nombre}</MenuItem>
                ))}
            </Select>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                id="fecha"
                label="Fecha"
                format="dd/MM/yyyy"
                value={fecha}
                onChange={setFecha}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                fullWidth
              />
            </MuiPickersUtilsProvider>
            <TextField
              label="Cantidad Baterias"
              type="number"
              value={cantidadBaterias}
              onChange={(e) => setCantidadBaterias(e.target.value)}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              disabled={!ensambladora || !fecha || !cantidadBaterias}
              onClick={handleAdd}
              style={{ marginTop: '10px' }}
            >
              Agregar
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default SostenibilidadBateriasContainer
